"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialListItem = exports.MaterialListItemUnstyled = exports.IListItemCategory = void 0;
const router_1 = require("client/components/router");
const material_ui_1 = require("material-ui");
const List_1 = require("material-ui/List");
const react_1 = require("react");
const React = require("react");
var IListItemCategory;
(function (IListItemCategory) {
    IListItemCategory[IListItemCategory["GroupHeader"] = 0] = "GroupHeader";
    IListItemCategory[IListItemCategory["Header"] = 1] = "Header";
    IListItemCategory[IListItemCategory["HeaderNoMargin"] = 2] = "HeaderNoMargin";
    IListItemCategory[IListItemCategory["Root"] = 3] = "Root";
})(IListItemCategory = exports.IListItemCategory || (exports.IListItemCategory = {}));
const decorate = material_ui_1.withStyles(theme => ({
    root: {
        borderBottom: "solid 1px rgba(0, 0, 0, 0.1)",
        cursor: "pointer",
        backgroundColor: "#fff",
        flex: "1 1 400px",
        height: "50px"
    },
    header: {
        backgroundColor: "#e9ebf1",
        cursor: "pointer",
        height: "45px",
        // textTransform: 'uppercase", // This line caused ts error
        width: "auto"
    },
    groupHeader: {
        backgroundColor: "#f1f3f8",
        cursor: "pointer",
        height: "36px"
    },
    headerNoMargin: {
        backgroundColor: "#e9ebf1",
        cursor: "pointer",
        height: "45px",
        // textTransform: 'uppercase', // This line caused ts error
        width: "auto"
    }
}));
class MaterialListItemUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClick = (e) => {
            const { onClick, to } = this.props;
            if (to) {
                router_1.RouteManager.transitionTo(to);
            }
            onClick && onClick(e);
        };
    }
    render() {
        const { children, inventoryId, inventoryPriority, quantityToRun, classes, category, className } = this.props;
        let style;
        switch (category) {
            case IListItemCategory.GroupHeader:
                style = classes.groupHeader;
                break;
            case IListItemCategory.Header:
                style = classes.header;
                break;
            case IListItemCategory.HeaderNoMargin:
                style = classes.headerNoMargin;
                break;
            default:
                style = classes.root;
        }
        let styleOveride = {};
        if (this.props.erxQty <= this.props.startingQuantity) {
            styleOveride = { backgroundColor: "rgba(30, 193, 114, 0.05)" };
        }
        return (React.createElement(List_1.ListItem, { style: styleOveride, classes: {
                root: style
            }, className: className, onClick: this.handleClick, "data-inventory-id": inventoryId, "data-inventory-priority": inventoryPriority, "data-quantity-to-run": quantityToRun }, children));
    }
}
exports.MaterialListItemUnstyled = MaterialListItemUnstyled;
exports.MaterialListItem = decorate(MaterialListItemUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/list/list-item/list-item.tsx
// module id = 3229
// module chunks = 0